import { AxiosInstance } from 'axios';
import {
  ISearchResultsParams,
  TSearchResultsCountResponse,
  ISearchResultsResponse,
  ISearchOptions,
} from '@sv-support-sdk/shared-types/src/api/search';
import convertParamsToUrl from '@sv-support-sdk/utils/src/helpers/convertParamsToUrl';

export default (api: AxiosInstance) => ({
  getSearchResultsCount: (searchValue: string, options?: ISearchOptions): Promise<TSearchResultsCountResponse> =>
    api.get(`/search/count?q=${searchValue}`, options),
  searchResults: (params: ISearchResultsParams, options?: ISearchOptions): Promise<ISearchResultsResponse> => {
    return api.get(
      `search?${convertParamsToUrl({
        ...params,
        per_page: params.per_page.toString(),
        page: params.page.toString(),
      })}`,
      options,
    );
  },
});
